exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.maintenance-area[data-v-5afd8f84] {\n  width: 100%;\n  margin: 0 auto;\n  padding-top: 100px;\n  box-sizing: border-box;\n  text-align: center;\n}\n.maintenance-ttl[data-v-5afd8f84] {\n  box-sizing: border-box;\n  font-size: 1.6rem;\n  line-height: 2.0rem;\n  color: #ff8ea1;\n  padding-bottom: 50px;\n  font-weight: bold;\n}\n.maintenance-txt[data-v-5afd8f84] {\n  box-sizing: border-box;\n  font-size: 1.2rem;\n  line-height: 1.8rem;\n  text-align: center;\n  padding-bottom: 20px;\n}\n", ""]);

// exports
